import { createAction, props } from '@ngrx/store';
import {
  Provider,
  ProviderWebsite,
  ProviderContact,
  ProviderLogin,
  CreateOrUpdateProviderWebsiteDTO,
  CreateOrUpdateProviderContactDTO,
  CreateOrUpdateProviderLoginDTO,
  UpdateProviderLoginActiveFlagDTO,
} from '../../model/provider.model';

export const loadProviders = createAction('[Provider] Load Providers');

export const loadProvidersSuccess = createAction('[Provider] Load Providers Success', props<{ providers: Provider[] }>());

export const loadProvidersFailure = createAction('[Provider] Load Providers Failure', props<{ error: any }>());

export const loadProviderWebsites = createAction('[Provider Website] Load Provider Websites', props<{ providerId: number }>());

export const loadProviderWebsitesSuccess = createAction(
  '[Provider Website] Load Provider Websites Success',
  props<{ providerId: number; websites: ProviderWebsite[] }>(),
);

export const loadProviderWebsitesFailure = createAction('[Provider Website] Load Provider Websites Failure', props<{ error: any }>());

export const createProviderWebsite = createAction(
  '[Provider Website] Create Provider Website',
  props<{ providerId: number; websiteData: CreateOrUpdateProviderWebsiteDTO }>(),
);

export const createProviderWebsiteSuccess = createAction(
  '[Provider Website] Create Provider Website Success',
  props<{ providerId: number; website: ProviderWebsite }>(),
);

export const createProviderWebsiteFailure = createAction('[Provider Website] Create Provider Website Failure', props<{ error: any }>());

export const updateProviderWebsite = createAction(
  '[Provider Website] Update Provider Website',
  props<{ providerId: number; websiteId: number; websiteData: CreateOrUpdateProviderWebsiteDTO }>(),
);

export const updateProviderWebsiteSuccess = createAction(
  '[Provider Website] Update Provider Website Success',
  props<{ providerId: number; website: ProviderWebsite }>(),
);

export const updateProviderWebsiteFailure = createAction('[Provider Website] Update Provider Website Failure', props<{ error: any }>());

export const deleteProviderWebsite = createAction('[Provider Website] Delete Provider Website', props<{ providerId: number; websiteId: number }>());

export const deleteProviderWebsiteSuccess = createAction(
  '[Provider Website] Delete Provider Website Success',
  props<{ providerId: number; websiteId: number }>(),
);

export const deleteProviderWebsiteFailure = createAction('[Provider Website] Delete Provider Website Failure', props<{ error: any }>());

export const loadProviderContacts = createAction('[Provider Contact] Load Provider Contacts', props<{ providerId: number }>());

export const loadProviderContactsSuccess = createAction(
  '[Provider Contact] Load Provider Contacts Success',
  props<{ providerId: number; contacts: ProviderContact[] }>(),
);

export const loadProviderContactsFailure = createAction('[Provider Contact] Load Provider Contacts Failure', props<{ error: any }>());

export const createProviderContact = createAction(
  '[Provider Contact] Create Provider Contact',
  props<{ providerId: number; contactData: CreateOrUpdateProviderContactDTO }>(),
);

export const createProviderContactSuccess = createAction(
  '[Provider Contact] Create Provider Contact Success',
  props<{ providerId: number; contact: ProviderContact }>(),
);

export const createProviderContactFailure = createAction('[Provider Contact] Create Provider Contact Failure', props<{ error: any }>());

export const updateProviderContact = createAction(
  '[Provider Contact] Update Provider Contact',
  props<{ providerId: number; contactId: number; contactData: CreateOrUpdateProviderContactDTO }>(),
);

export const updateProviderContactSuccess = createAction(
  '[Provider Contact] Update Provider Contact Success',
  props<{ providerId: number; contact: ProviderContact }>(),
);

export const updateProviderContactFailure = createAction('[Provider Contact] Update Provider Contact Failure', props<{ error: any }>());

export const deleteProviderContact = createAction('[Provider Contact] Delete Provider Contact', props<{ providerId: number; contactId: number }>());

export const deleteProviderContactSuccess = createAction(
  '[Provider Contact] Delete Provider Contact Success',
  props<{ providerId: number; contactId: number }>(),
);

export const deleteProviderContactFailure = createAction('[Provider Contact] Delete Provider Contact Failure', props<{ error: any }>());

export const loadProviderLogins = createAction('[Provider Login] Load Provider Logins', props<{ providerId: number }>());

export const loadProviderLoginsSuccess = createAction(
  '[Provider Login] Load Provider Logins Success',
  props<{ providerId: number; logins: ProviderLogin[] }>(),
);

export const loadProviderLoginsFailure = createAction('[Provider Login] Load Provider Logins Failure', props<{ error: any }>());

export const createProviderLogin = createAction(
  '[Provider Login] Create Provider Login',
  props<{ providerId: number; loginData: CreateOrUpdateProviderLoginDTO }>(),
);

export const createProviderLoginSuccess = createAction('[Provider Login] Create Provider Login Success', props<{ providerId: number; login: ProviderLogin }>());

export const createProviderLoginFailure = createAction('[Provider Login] Create Provider Login Failure', props<{ error: any }>());

export const updateProviderLogin = createAction(
  '[Provider Login] Update Provider Login',
  props<{ providerId: number; loginId: number; loginData: CreateOrUpdateProviderLoginDTO }>(),
);

export const updateProviderLoginSuccess = createAction('[Provider Login] Update Provider Login Success', props<{ providerId: number; login: ProviderLogin }>());

export const updateProviderLoginFailure = createAction('[Provider Login] Update Provider Login Failure', props<{ error: any }>());

export const updateProviderLoginActiveFlag = createAction(
  '[Provider Login] Update Provider Login Active Flag',
  props<{ providerId: number; loginId: number; activeData: UpdateProviderLoginActiveFlagDTO }>(),
);

export const updateProviderLoginActiveFlagSuccess = createAction(
  '[Provider Login] Update Provider Login Active Flag Success',
  props<{ providerId: number; login: ProviderLogin }>(),
);

export const updateProviderLoginActiveFlagFailure = createAction('[Provider Login] Update Provider Login Active Flag Failure', props<{ error: any }>());

export const deleteProviderLogin = createAction('[Provider Login] Delete Provider Login', props<{ providerId: number; loginId: number }>());

export const deleteProviderLoginSuccess = createAction('[Provider Login] Delete Provider Login Success', props<{ providerId: number; loginId: number }>());

export const deleteProviderLoginFailure = createAction('[Provider Login] Delete Provider Login Failure', props<{ error: any }>());
